<template>
  <div id="app">
    <PasswordForm v-if="showPasswordForm" @submit="verifyPassword" />
    <ImageGallery v-if="showImageGallery" :images="images" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import imagesData from "@/config/images.json";
import passwords from "@/config/passwords.json";
import PasswordForm from "@/components/PasswordForm.vue";
import ImageGallery from "@/components/ImageGallery.vue";
import { Image } from "@/config/types";

export default defineComponent({
  name: "App",
  components: {
    PasswordForm,
    ImageGallery,
  },
  setup() {
    const showPasswordForm = ref(true);
    const showImageGallery = ref(false);
    const images = ref<Image[]>([]);

    const verifyPassword = (password: string) => {
      const directory = (passwords as { [key: string]: string })[password];
      if (directory) {
        showPasswordForm.value = false;
        showImageGallery.value = true;
        images.value = imagesData
          .filter((image) => image.src.startsWith(directory))
          .map((image) => ({
            ...image,
            src: `${image.src}`,
          }));
      } else {
        alert("密码错误");
      }
    };

    return {
      showPasswordForm,
      showImageGallery,
      images,
      verifyPassword,
    };
  },
});
</script>

<style></style>
